/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_RefreshInputs */



/**
* | output |
* | --- |
* | "Refresh" |
*
* @param {Update_RefreshInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const update_refresh = /** @type {((inputs?: Update_RefreshInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_RefreshInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Actualiser")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Atualizar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna")
	return /** @type {LocalizedString} */ ("Refresh")
});